// Apolo IDE — pluginColor.
//
// Deterministic plugin/namespace → color. The skill pickers identify each
// entry by COLOR instead of an icon: every plugin family (accessibility-agents,
// marketing-skills, gsap-skills, anthropic-skills, …) gets a stable hue, so a
// long list reads as color-coded groups and you can scan by family.
//
// Curated palette (bright enough on the dark surface for rails, tints, and
// text). Indexed by a stable hash of the slug, so the same plugin is always
// the same color and different plugins are very likely distinct.

export const PLUGIN_PALETTE = [
  '#3b82f6', // blue
  '#8b5cf6', // violet
  '#10b981', // emerald
  '#f59e0b', // amber
  '#ef4444', // red
  '#06b6d4', // cyan
  '#ec4899', // pink
  '#84cc16', // lime
  '#f97316', // orange
  '#14b8a6', // teal
  '#6366f1', // indigo
  '#a855f7', // purple
  '#0ea5e9', // sky
  '#22c55e', // green
  '#e879f9', // fuchsia
  '#f43f5e', // rose
];

function hash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = (h * 31 + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

// Stable color for a plugin slug. Falls back to a neutral-ish hue for
// empty/unknown slugs (e.g. local-only commands without a plugin).
export function pluginColor(slug) {
  const key = (slug == null ? '' : String(slug)).trim().toLowerCase();
  if (!key) return PLUGIN_PALETTE[0];
  // ((x % n) + n) % n keeps the index non-negative even for the one int32 value
  // where Math.abs overflows (-2147483648).
  const idx = ((hash(key) % PLUGIN_PALETTE.length) + PLUGIN_PALETTE.length) % PLUGIN_PALETTE.length;
  return PLUGIN_PALETTE[idx];
}

// '#rrggbb' + alpha(0..1) → 'rgba(r, g, b, a)'. Used for tints (active row,
// badge background) so the same hue drives rail + fill at different strengths.
export function withAlpha(hex, alpha) {
  const h = String(hex || '').replace('#', '');
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return `rgba(59, 130, 246, ${alpha})`;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
